import { useQuery } from "@tanstack/react-query";
import { fetchWeeklyOvertimeHours } from "../api/overtimeApi";

export function useWeeklyOvertimeHours(params?: { weekOf?: string; excludeShiftId?: number }) {
  return useQuery({
    queryKey: ["overtime-weekly-hours", params ?? {}],
    queryFn: () => fetchWeeklyOvertimeHours(params),
    staleTime: 30_000,
  });
}
